import * as React from 'react';
import { Image, Text, View, StyleSheet, FlatList, TouchableOpacity, ActivityIndicator, ScrollView, Linking} from 'react-native';
import NewButton from './NewButton';
import { Colors, Fonts } from '../utils/Constants';
import ReactGA from 'react-ga';

export class SocialActionModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state={
            loading: true,
            deviceType: this.getDeviceType()
        };
    }
    getDeviceType = () => {
        if ((/iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
        !window.MSStream) {
          return "ios";
        }
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf("android") > -1) return "android";
        return "desktop";
    }

    openSocialMedia = (socialPlatform) => {
        ReactGA.event({
            category: 'Social',
            action: 'Share Progress',
            label: socialPlatform.name
        });
        let textToShare = encodeURIComponent(`I did my part to support the ${this.props.name} movement. Will you do your part and join me?`);
        let shareLink = `${window.location.href}`;
        if (socialPlatform.name === 'insta') {
            var link = ((this.state.deviceType + "_url") in socialPlatform) ? socialPlatform[this.state.deviceType + "_url"] : socialPlatform["desktop_url"];
            Linking.openURL(link);
        } else if (socialPlatform.name === 'fb') {
            window.open(`https://www.facebook.com/sharer.php?u=`);
        }
        else if (socialPlatform.name === 'linkedin') {
            window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${shareLink}`);
        }
        else if (socialPlatform.name === 'twitter') {
            let base = `https://twitter.com/intent/tweet?`;
            let link = `${base}url=${shareLink}&text=${textToShare}`
            window.open(link);
        }
        else if (socialPlatform.name === 'reddit') {
            window.open(`https://reddit.com/submit?url=${shareLink}&title=${'Do Your Part to Help ' + this.props.name}`);
        }
    }

    render() {
        let image_style = this.props.width === 500 ? {width: 300, height: 534} : {width: this.props.parentWidth*0.5, height: this.props.parentWidth*0.96};
        return (
            <View style={{backgroundColor: 'white', alignItems: 'center', width: this.props.width, maxHeight: '90%'}}>
                <TouchableOpacity style={{alignSelf: 'flex-start', marginLeft: 20, marginTop: 20}} onPress={this.props.close}>
                    <Image
                        source={require('../assets/images/close.png')}
                        style={{height: 20, width: 20}}
                    />
                </TouchableOpacity>
                <ScrollView style={{width: '90%', padding: 20}}>
                    <Text style={[styles.text, {fontSize: 20, fontWeight: 'bold', marginBottom: 10}]}>
                        Share Impact
                    </Text>
                    <Text style={[styles.text, {fontSize: 20, fontWeight: 'regular', marginBottom: 10}]}>
                        {this.state.loading ? "generating custom image":"press and hold to save this image"}
                    </Text>
                    <View>
                        <ActivityIndicator
                            animating={this.state.loading}
                            size="large" color="black"
                        />
                        {!!this.props.imageLink && <Image
                            style={[image_style, {marginBottom: 10}]}
                            resizeMode={"contain"}
                            source={this.props.imageLink}
                            onLoad={()=> this.setState({loading: false})}
                        />}
                    </View>
                    <FlatList
                        data={shareItems}
                        keyExtractor={item => item.text}
                        renderItem={({ item }) => (
                            <NewButton textColor='black' text={item.text} color='white' font='normal' fontSize={this.props.width === '90%' ? 15 : 20} marginBottom={16}
                                justifyContent={'flex-start'} image={item.image} action={() => this.openSocialMedia(item)} height={50}
                            />
                        )}
                    />
                </ScrollView>
            </View>
        );
    }
}

//https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share
//native share
const shareItems = [
    {
        image:require('../assets/images/Instagram.svg'),
        text:'Share to Instagram',
        desktop_url: 'https://instagram.com',
        ios_url:'instagram://story-camera',
        android_url:'intent://story-camera#Intent;package=com.instagram.android;scheme=https;end',
        name: 'insta'
    },
    {
        image:require('../assets/images/Twitter.svg'),
        text:'Share to Twitter',
        url:'https://twitter.com',
        name: 'twitter'
    },
    {
        //https://stackoverflow.com/questions/5707722/what-are-all-the-custom-url-schemes-supported-by-the-facebook-iphone-app/5707825#5707825
        image:require('../assets/images/Facebook.svg'),
        text:'Share to Facebook',
        desktop_url: 'https://instagram.com',
        ios_url:'instagram://story-camera',
        android_url:'intent://story-camera#Intent;package=com.instagram.android;scheme=https;end',
        name: 'fb'
    },
    {
        image:require('../assets/images/LinkedIn.svg'),
        text:'Share to LinkedIn',
        name: 'linkedin'
    },
    {
        image:require('../assets/images/Reddit.svg'),
        text:'Share to Reddit',
        name: 'reddit'
    },
];


export class SocialActions extends React.PureComponent {
    render() {
        let items = this.props.items;
        let firstColumn = items.slice(0, Math.ceil(items.length/2));
        let secondColumn = items.slice(Math.ceil(items.length/2));
        return (
            <View style={styles.socialView}>
                <View style={{flexDirection: 'row', justifyContent: 'space-between', marginBottom: 15}}>
                    <View>
                        {
                        firstColumn.map((item) => (
                            <Text key={item.action_type} style={{color: 'white', textAlign: 'left', fontSize: 12, marginBottom: 15}}>
                                <Text style={{fontWeight: 'bold', color: 'white', fontSize: 18}}>
                                    {item.number_completed}
                                </Text>
                                {"\n" + item.short_phrase_desktop}
                            </Text>
                        ))
                        }
                    </View>
                    <View style={{marginLeft: 10}}>
                        {
                        secondColumn.map((item) => (
                            <Text key={item.action_type} style={{color: 'white', textAlign: 'left', fontSize: 12, marginBottom: 15}}>
                                <Text style={{fontWeight: 'bold', color: 'white', fontSize: 18}}>
                                    {item.number_completed}
                                </Text>
                                {"\n" + item.short_phrase_desktop}
                            </Text>
                        ))
                        }
                    </View>
                </View>

                <NewButton image={require('../assets/images/Share.svg')} textColor='black' text='Share Impact' color='white' width={170} height={38.15} font='Bold' fontSize={14.14} marginBottom={16} action={this.props.shareProgress}/>
                {/* <NewButton textColor='#33789B' text='Show Completed' color='#F2F6F8' width={170} height={38.15} border={5.41} font='Bold' fontSize={14.14} borderColor={'#33789B'} action={this.props.showCompleted} borderWidth={1}/> */}
            </View>
        );
    }
}

const styles = StyleSheet.create({
    socialMedia: {
      width: 194,
      height: 110,
      padding: 15,
      alignItems: 'center',
      borderRadius: 6.49,
      borderColor: 'black',
      borderWidth: 1,
      justifyContent: 'center',
    },
    text: {
      color: 'black',
      fontSize: 13.44,
      fontFamily: Fonts.mainFont
    },
    socialView: {
        backgroundColor: 'black',
        //borderRadius: 6.49,
        // width: 200,
        padding: 15,
        alignItems: 'center',
        justifyContent: 'center'
    }
  });